// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-checkbox[data-v-c02276a8]{display:flex;align-items:center}.x-checkbox[data-v-c02276a8] .v-input--selection-controls{margin-top:0;padding-top:0}", ""]);
// Exports
module.exports = exports;
